import { render, staticRenderFns } from "./PixDescription.vue?vue&type=template&id=07c81a0c&scoped=true"
import script from "./PixDescription.vue?vue&type=script&lang=js"
export * from "./PixDescription.vue?vue&type=script&lang=js"
import style0 from "./PixDescription.vue?vue&type=style&index=0&id=07c81a0c&prod&lang=scss&scoped=true"
import style1 from "./PixDescription.vue?vue&type=style&index=1&id=07c81a0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c81a0c",
  null
  
)

export default component.exports